import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import breadcrumbService from './services/breadcrumb-service'
import shopService from './services/shop-service'
import offerService from './services/offer-service'
import notificationService from './services/notification-service'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    breadcrumbService,
    shopService,
    offerService,
    notificationService
  }
})
